<template>
   <form @submit.prevent>
      <CModal
         :title.sync="title"
         color="info"
         size="lg"
         :closeOnBackdrop="false"
         :show.sync="show"
      >
         <CRow>
            <CCol>
               <label> Curriculum Name </label>
               <CRow>
                  <CCol>
                     <b-input
                        v-model="form.name"
                        placeholder="Curriculum name"
                        id="feedback-user"
                        class="mb-1"
                        :class="errors.name ? 'is-invalid' : ''"
                     >
                     </b-input>
                     <b-form-invalid-feedback>
                        Your Curriculum name must be filled
                     </b-form-invalid-feedback>
                  </CCol>
               </CRow>
            </CCol>
         </CRow>
         <CRow class="mt-3">
            <CCol>
               <label>Description Curriculum </label>
               <CRow>
                  <CCol sm="12">
                     <c-textarea
                        v-model="form.description"
                        rows="4"
                        :class="errors.descripion ? 'is-invalid' : ''"
                     />
                     <b-form-invalid-feedback>
                        Your Curriculum description must be filled
                     </b-form-invalid-feedback>
                  </CCol>
               </CRow>
               <CRow hidden>
                  <CCol sm="12">
                     <label>Type Class </label>
                     <!-- <label> <b> Category Event  </b></label> -->
                     <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-radio-group
                           v-model="form.type"
                           :aria-describedby="ariaDescribedby"
                        >
                           <b-form-radio
                              :aria-describedby="ariaDescribedby"
                              name="category"
                              value="1"
                              >Singleclass</b-form-radio
                           >
                           <b-form-radio
                              :aria-describedby="ariaDescribedby"
                              name="category"
                              value="2"
                              >Multiclass</b-form-radio
                           >
                        </b-form-radio-group>
                     </b-form-group>
                  </CCol>
               </CRow>
               <CRow class="mt-3">
                  <CCol sm="12">
                     <label> Curriculum Category </label>
                     <!-- <label> <b> Category Event  </b></label> -->
                     <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-radio-group
                           v-model="form.is_publish"
                           :aria-describedby="ariaDescribedby"
                           :class="errors.is_publish ? 'is-invalid' : ''"
                        >
                           <b-form-radio
                              :aria-describedby="ariaDescribedby"
                              name="is_publish"
                              value="1"
                              >Public</b-form-radio
                           >
                           <b-form-radio
                              :aria-describedby="ariaDescribedby"
                              name="is_publish"
                              value="2"
                              >Private</b-form-radio
                           >
                        </b-form-radio-group>
                        <b-form-invalid-feedback>
                           Your Curriculum category must be selected
                        </b-form-invalid-feedback>
                     </b-form-group>
                  </CCol>
               </CRow>
               <CRow>
                  <CCol>
                     <label class="mt-3"> Required Curriculum </label>
                     <multiselect
                        v-model="form.required_class"
                        placeholder=""
                        :options="listbatch"
                        label="text"
                        track-by="value"
                        :multiple="true"
                     ></multiselect>
                  </CCol>
               </CRow>
               <CRow class="mt-3">
                  <CCol sm="12">
                     <label> User Type </label>
                     <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-radio-group
                           v-model="form.user_type"
                           :aria-describedby="ariaDescribedby"
                           :class="errors.user_type ? 'is-invalid' : ''"
                        >
                           <b-form-radio
                              :aria-describedby="ariaDescribedby"
                              name="user_type"
                              value="1"
                              >All</b-form-radio
                           >
                           <b-form-radio
                              :aria-describedby="ariaDescribedby"
                              name="user_type"
                              value="2"
                              >Member Only</b-form-radio
                           >
                        </b-form-radio-group>
                        <b-form-invalid-feedback>
                           Your Curriculum category must be selected
                        </b-form-invalid-feedback>
                     </b-form-group>
                  </CCol>
               </CRow>
               <hr />
               <CRow class="mt-3">
                  <CCol>
                     <div>
                        <label> Background Image </label>
                     </div>
                     <b-form-file
                        v-if="mode === 'create'"
                        size="sm"
                        v-model="form.bg_image"
                        class="mt-3"
                        plain
                        :class="errors.bg_image ? 'is-invalid' : ''"
                     ></b-form-file>
                     <img
                        v-bind:src="getImage(bg_image_url)"
                        style="width:250px"
                     />

                     <CButton
                        v-if="mode === 'edit'"
                        class="mt-3"
                        type="button"
                        @click="openModalPhotoBGImage(form.id)"
                        variant="outline"
                        color="info"
                        >Update BG Image</CButton
                     >
                     <b-form-invalid-feedback>
                        Your BG image must be added
                     </b-form-invalid-feedback>
                  </CCol>
                  <CCol>
                     <div>
                        <label> Banner Image </label>
                     </div>
                     <b-form-file
                        v-if="mode === 'create'"
                        size="sm"
                        v-model="form.banner_image"
                        class="mt-3"
                        plain
                        :class="errors.banner_image ? 'is-invalid' : ''"
                     ></b-form-file>

                     <img
                        v-bind:src="getImage(banner_image_url)"
                        style="width:250px"
                     />

                     <CButton
                        v-if="mode === 'edit'"
                        class="mt-3"
                        type="button"
                        @click="openModalPhotoBannerImage(form.id)"
                        variant="outline"
                        color="info"
                        >Update Banner Image</CButton
                     >
                     <b-form-invalid-feedback>
                        Your Banner image must be added
                     </b-form-invalid-feedback>
                  </CCol>
               </CRow>
            </CCol>
         </CRow>
         <template #footer>
            <CButton @click="show = false" color="danger">Cancel</CButton>
            <CButton
               v-if="mode === 'create'"
               type="submit"
               v-on:click.prevent="create()"
               variant="outline"
               color="info"
               >Create</CButton
            >
            <CButton
               v-if="mode === 'edit'"
               type="submit"
               v-on:click.prevent="update(form.id)"
               variant="outline"
               color="info"
               >Edit</CButton
            >
         </template>
         <!-- <pre>{{ $data }}</pre> -->
      </CModal>
      <modalphotobg></modalphotobg>
      <modalphotobanner></modalphotobanner>
   </form>
</template>

<script>
import axios from "axios";

import EventBus from "@/eventBus";

import classbatch from "@/services/batch";

import _ from "lodash";
import Multiselect from "vue-multiselect";

import modalphotobg from "./curriculum_photo_bgimage.vue";
import modalphotobanner from "./curriculum_photo_bannerimage.vue";

export default {
   name: "batchmodal",

   components: {
      modalphotobg,
      modalphotobanner,
      Multiselect,
   },
   data() {
      return {
         show: false,
         title: "Default Title",
         mode: "",
         errors: {},
         errors_from_backend: [],
         form: {
            name: "",
            description: "",
            is_publish: "",
            bg_image: "",
            banner_image: "",
            required_class: [],
            user_type:"",
            type: "2",
         },
         bg_image_url: "",
         banner_image_url: "",
         listbatch: [],
         required_listbatch:[],
         loading: false,
      };
   },
   computed: {},
   created() {
      var self = this;
      EventBus.$on("OPEN_MODAL_BATCH", (params) => {
         if (params.data) {
            classbatch
               .getBatchbyID(params.data)
               .then((res) => {
                  self.show = true;
                  self.title = params.title;
                  self.mode = params.mode;
                  self.form.id = res.data.id;
                  self.form.name = res.data.name;
                  self.form.description = res.data.description;
                  self.form.type = res.data.type;
                  self.form.is_publish = res.data.is_publish;
                  self.form.user_type = res.data.user_type
                  self.bg_image_url = res.data.bg_image_url;
                  self.banner_image_url = res.data.banner_image_url;
                  var required_class = JSON.parse( res.data.required_class);
                  self.form.required_class = self.listbatch.filter(item => required_class.includes(item.value))
               })
               .catch((err) => {
                  var params = {
                     title: "Error",
                     mode: "danger",
                     data: err.response.data.message,
                  };
                  EventBus.$emit("OPEN_MODAL_ALERT", params);
               });
         } else {
            self.show = true;
            self.title = params.title;
            self.mode = params.mode;
            self.form.name = "";
            self.form.description = "";
            self.form.type = "2";
            self.form.is_publish = "";
            self.form.user_type = "",
            self.form.bg_image = "";
            self.form.banner_image = "";
            self.form.banner_image = "";
         }
      });
   },
   mounted() {
      this.load();
   },

   methods: {
      open() {
         this.show = true;
      },
      close() {
         this.show = false;
      },
      create() {
         this.loading = true;
         let formData = new FormData();
         formData.append("name", this.form.name);
         formData.append("is_publish", this.form.is_publish);
         formData.append("type", this.form.type);
         formData.append("user_type",this.form.user_type)
         formData.append(
            "description",
            this.form.description ? this.form.description : ""
         );
         formData.append("bg_image", this.form.bg_image);
         formData.append("banner_image", this.form.banner_image);
         formData.append(
            "required_class",
            JSON.stringify(this.form.required_class.map((item) => item.value))
         );
         if (this.check_form()) {
            classbatch
               .createBatch(formData)
               .then((res) => {
                  this.loading = false;
                  this.show = false;
                  EventBus.$emit("TABLE_UPDATE", true);
                  var params = {
                     title: "Success",
                     mode: "success",
                     data: res.message,
                  };
                  EventBus.$emit("OPEN_MODAL_ALERT", params);
               })
               .catch((err) => {
                  this.loading = false;
                  alert(err.response.data.message);
                  //alert(JSON.stringify(err.response.data.errors));
                  if (err.response.data.errors != null) {
                     this.errors_from_backend = err.response.data.errors;
                     console.log(JSON.stringify(err.response.data.errors));
                  }
               });
         } else {
            this.loading = false;
         }
      },
      update(id) {
         this.show = false;
         let formData = new FormData();
         formData.append("name", this.form.name);
         formData.append("is_publish", this.form.is_publish);
         formData.append("type", this.form.type);
         formData.append("user_type",this.form.user_type)
         formData.append(
            "description",
            this.form.description ? this.form.description : ""
         ); //fix bug if description empty send "null"
         formData.append("bg_image", this.form.bg_image);
         formData.append("banner_image", this.form.banner_image);
         formData.append(
            "required_class",
            JSON.stringify(this.form.required_class.map((item) => item.value))
         );

         classbatch
            .updateBatch(id, formData)
            .then((res) => {
               EventBus.$emit("TABLE_UPDATE", true);
               var params = {
                  title: "Success",
                  mode: "success",
                  data: res.message,
               };
               EventBus.$emit("OPEN_MODAL_ALERT", params);
            })
            .catch((err) => {
               var params = {
                  title: "Error",
                  mode: "danger",
                  data: err.response.data.message,
               };
               EventBus.$emit("OPEN_MODAL_ALERT", params);
            });
      },
      check_form: function(e) {
         this.errors = {};
         if (!this.form.name) {
            this.errors["name"] = "1";
         }
         if (!this.form.description) {
            this.errors["descripion"] = "1";
         }
         if (!this.form.is_publish) {
            this.errors["is_publish"] = "1";
         }
         if (!this.form.user_type) {
            this.errors["user_type"] = "1";
         }
         if (!this.form.bg_image) {
            this.errors["bg_image"] = "1";
         }
         if (!this.form.banner_image) {
            this.errors["banner_image"] = "1";
         }

         if (
            this.form.name &&
            this.form.description &&
            this.form.user_type &&
            this.form.is_publish &&
            this.form.bg_image &&
            this.form.banner_image
         ) {
            return true;
         } else {
            return false;
         }
      },
      load() {
         classbatch.getBatch().then((res) => {
            for (let i = 0; i <= res.data.length - 1; i++) {
               //alert
               this.listbatch.push({
                  text: res.data[i].name,
                  value: res.data[i].id,
               });
            }
         });
         // classbatch.getBatch()
         // .then(res => {
         //     let getData = res
         //     this.listbatch = getData.data
         //     for (var i = 0; i < getData.data.listbatch.length; i++) {
         //       this.form.required_class.push(getData.data.listbatch[i].id);
         //     }
         // }).catch ((err) => {
         //   var params = {title: 'Error', mode:'danger', data:err.response.data.message}
         //   EventBus.$emit('OPEN_MODAL_ALERT', params)
         // })
      },
      openModalPhotoBGImage(id) {
         var params = { title: "Update BG Image", mode: "edit", data: id };
         EventBus.$emit("OPEN_MODAL_EVENT_PHOTO_BGIMAGE", params);
      },
      openModalPhotoBannerImage(id) {
         var params = { title: "Update Banner Image", mode: "edit", data: id };
         EventBus.$emit("OPEN_MODAL_EVENT_PHOTO_BANNERIMAGE", params);
         console.log("load modal photo");
      },
      getPhoto(data) {
         if (data) {
            return (
               axios.defaults.baseURL +
               "/getfile/" +
               data.path +
               "/" +
               data.filename
            );
         } else {
            return axios.defaults.baseURL + "/getfile/memberphoto/no_photo.jpg";
         }
      },
      getImage(url) {
         if (url) {
            return url;
         } else {
            return "";
         }
      },
   },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
